module.exports = __webpack_public_path__ + "img/bttn_eccl_map.4bacee11.png";